<template>
  <div>
    <rec ref="rec"></rec>
    <pro ref="pro" :isaAbnormal="true" :project="project"></pro>
    <cash ref="cash" :project="project"></cash>
    <repay ref="repay"></repay>
    <refRec ref="refRec"></refRec>
    <refPro ref="refPro"></refPro>
    <refCash ref="refCash"></refCash>
    <protopro ref="protopro"></protopro>
    <protorec ref="protorec"></protorec>
    <promotion ref="promotion"></promotion>
    <transfer ref="transfer"></transfer>
    <cancelDeb ref="cancelDeb"></cancelDeb>

  </div>
</template>

<script>
import rec from "@/pages/eashier/collectionList/components/detail.vue";
import pro from "@/pages/eashier/reatment/components/detail.vue";
import cash from "@/pages/eashier/proceeds/detail/editform.vue";
import refRec from "@/pages/eashier/refundRecharge/components/detail.vue";
import refPro from "@/pages/eashier/refundCourse/components/detail.vue";
import refCash from "@/pages/eashier/refund/components/detail.vue";
import protopro from "@/pages/eashier/raiseReatment/components/detail.vue";
import protorec from "@/pages/eashier/coursetorec/components/detail.vue";
import repay from "@/pages/eashier/repayment/components/index.vue";
import promotion from "@/pages/promotion/sellpacking/components/detail.vue";
import transfer from "@/pages/storeManage/transferNew/components/detail.vue";
import cancelDeb from './cancelDeb.vue'

import {
  recDetail,
  proDetail,
  cashDetail,
  cardChangeDetail,
  protoDetail,
  repayDetail,
  refOrderDetail,
  promotionDetail,
  canceSelectById
} from "@/api/eashier.js";
import {
  turnMembershipCardPage,
} from "@/api/storeManage.js";
export default {
  components: {
    transfer,
    rec,
    pro,
    cash,
    refRec,
    refPro,
    refCash,
    protopro,
    protorec,
    promotion,
    repay,
    cancelDeb
  },
  data() {
    return {
      form: {}, //主对象
      itemList: [
        //单据全部类型

        {
          docType: "upgrade_out",
          docTypeName: "升级转出",
        },
        {
          docType: "upgrade_in",
          docTypeName: "升级充值",
        },
        {
          docType: "demotion_out",
          docTypeName: "降级转出",
        },
        {
          docType: "demotion_in",
          docTypeName: "降级充值",
        },
        {
          docType: "init",
          docTypeName: "初始化",
        },
        {
          docType: "card_recharge",
          docTypeName: "充值开卡",
        },

        {
          docType: "recharge_roll_course",
          docTypeName: "疗程转充值卡",
        },
        {
          docType: "card_change",
          docTypeName: "加价转疗程",
        },
        {
          docType: "card_use",
          docTypeName: "疗程开卡",
        },
        {
          docType: "store_cash",
          docTypeName: "收银",
        },
        {
          docType: "card_repay",
          docTypeName: "还款",
        },
        {
          docType: "refund_recharge",
          docTypeName: "充值退款",
        },
        {
          docType: "refund_course",
          docTypeName: "疗程退款",
        },
        {
          docType: "refund_cash",
          docTypeName: "消费退款",
        },
        {
          docType: "promotion",
          docTypeName: "促销活动",
        },
        {
          docType: "promotion_card_repay",
          docTypeName: "促销还款",
        },
      ],
      project:{},
      queryForm: {
        //查询对象
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    //组件传值
    show(form, number) {
      if(form.project)this.project = form.project
      // number 1 异常单进入
      this.querForm = { pageNum: 1, pageSize: 10 };
      if (number == 1) {
        this.queryForm.id = form.id;
      } else {
        this.queryForm.id = form.docId;
        this.queryForm.storeId = form.storeId;
      }
      var item = {};
      console.log( form,number )
      //  type   
      // 0 充值
      // 1 疗程
      // 2 收银
      // 3 还款
      // 4 促销
      // 5 加价转疗程
      // 6 疗程转充值

      if (
        form.docType == "card_recharge" ||
        form.docType == "upgrade_out" ||
        form.docType == "upgrade_in" ||
        form.docType == "demotion_out" ||
        form.docType == "demotion_in" ||
        (number == 1 && form.type == 0)
      ) {
        //充值
        if (form.inputDate) {
          this.queryForm.selectDate = form.inputDate;
        } else {
          this.queryForm.selectDate = form.docDate ? form.docDate : form.date;
        }
        recDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.rec.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "card_use" || (number == 1 && form.type == 1)) {
        //疗程
        if (form.inputDate) {
          this.queryForm.selectDate = form.inputDate;
        } else {
          this.queryForm.selectDate = form.docDate ? form.docDate : form.date;
        }
        proDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.pro.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "store_cash" || (number == 1 && form.type == 2)) {
        //服务明细
        if (form.inputDate) {
          this.queryForm.selectDate = form.inputDate;
        } else {
          this.queryForm.selectDate = form.docDate ? form.docDate : form.date;
        }
        cashDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.cash.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "card_change" || (number == 1 && form.type == 5)) {
        //加价转疗程
        cardChangeDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.protopro.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (
        form.docType == "recharge_roll_course" ||
        (number == 1 && form.type == 6)
      ) {
        //疗程转充值
        protoDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.protorec.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (
        form.docType == "card_repay" ||
        form.docType == "promotion_card_repay" ||
        (number == 1 && form.type == 3)
      ) {
        //还款
        repayDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.repay.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "refund_recharge") {
        //退款
        this.queryForm.type = 0;
        refOrderDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.refRec.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "refund_course") {
        //疗程退款
        this.queryForm.type = 1;
        refOrderDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.refPro.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "refund_cash") {
        //消费退款
        this.queryForm.type = 2;
        refOrderDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.refCash.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if (form.docType == "dabao" || (number == 1 && form.type == 4)) {
        //促销活动
        promotionDetail(this.queryForm).then((res) => {
          if (res.code == "000000") {
            if (res.pageInfo.total == 0) {
              this.backCalls();
            } else {
              item = res.pageInfo.list[0];
              this.$refs.promotion.show(item, "明细");
            }
          } else {
            this.backCall(res);
          }
        });
      }
      if(form.docType == "turn_card_recharge" || form.docType =='turn_card_use'){
        let params = {
          docNum:form.docNum
        }
        turnMembershipCardPage(params).then(res=>{
          if (res.code == "000000") {
            this.$refs.transfer.show(res.pageInfo.list[0])
          } 
        })
      }
      // 取消欠款
      if(form.docType == 'cancel_Debt'){
        let params = {
          id:form.docId
        }
        canceSelectById(params).then(res=>{
          if(res.code == "000000"){
            let row = res.pageInfo.list[0]
            this.$refs.cancelDeb.init(row)
          }
        })
      }
      if (form.docType == "init") {
        this.$alert("初始化没有单据明细", "提示", {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmbtnFalses",
          type: "warning",
          center: true,
          callback: (action) => {},
        });
      }
    },
    backCall(res) {
      this.$alert(res.message, "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmbtnFalses",
        type: "warning",
        center: true,
        callback: (action) => {},
      });
    },
    backCalls() {
      this.$alert("没有找到相关明细", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmbtnFalses",
        type: "warning",
        center: true,
        callback: (action) => {},
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/order/detail.vue